import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, withCtx as _withCtx, createBlock as _createBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-21f67442"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["src"]
const _hoisted_2 = ["src"]
const _hoisted_3 = ["src"]
const _hoisted_4 = {
  key: 0,
  class: "d-flex align-items-center"
}
const _hoisted_5 = { class: "text-truncate fw-bold" }
const _hoisted_6 = { class: "d-flex position-absolute" }
const _hoisted_7 = {
  key: 0,
  class: "more-user px-2 fs-8 d-flex justify-content-center align-items-center text-white fw-bold"
}
const _hoisted_8 = {
  key: 1,
  class: "more-user px-2 fs-8 d-flex justify-content-center align-items-center text-white fw-bold"
}
const _hoisted_9 = {
  key: 0,
  class: "d-flex align-items-center ms-lg-4 ms-2"
}
const _hoisted_10 = { class: "text-truncate fw-bold mb-0" }
const _hoisted_11 = {
  key: 4,
  class: "main d-flex justify-content-between align-items-center w-100"
}
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "fs-9 title fw-bold" }, null, -1))
const _hoisted_13 = { class: "user align-items-center d-flex" }
const _hoisted_14 = {
  key: 0,
  class: "d-flex align-items-center"
}
const _hoisted_15 = {
  key: 0,
  class: "user__name fs-75 fw-bold d-none d-lg-flex"
}
const _hoisted_16 = ["src"]

import { ref, watchEffect, computed, ComputedRef, onMounted, watch, PropType } from 'vue'
import ButtonScrollTop from '@/components/button-scroll-top/index.vue'
import Notification from '@/components/notification/index.vue'
import UserMenu from '@/components/header/user-menu/index.vue'
import { useAuthenticated } from '@/use/authentication'
import { useLogoImage } from '@/use/headerLogo'
import { useStore } from 'vuex'
import { CommunityStateTypes } from '@/store/modules/community'
import { AUTH_STORE, COMMUNITY_STORE } from '@/store/constants'
import { addCommunityHeaderParams, addUserIconParams, userType, usePath } from '@/use/usePath'
import { useRoute, useRouter } from 'vue-router'
import { ROOT_STORE } from '@/store/constants'
import ModalLogout from '../modal-logout/index.vue'
import ModalDetailNotification from '@/components/notification/components/ModalDetail.vue'
import userService from '@/services/auth.service'
import communityServices from '@/services/communities.service'
import Avatar from '@/components/avatar'
import NProgress from 'nprogress/nprogress'
import { numberWithCommas } from '@/constants/common.ts'


export default /*#__PURE__*/_defineComponent({
  props: {
  ShowMembership: {
    type: Function as PropType<() => void | undefined>,
  },
  ShowMembershipAlumni: {
    type: Function as PropType<() => void | undefined>,
  },
},
  setup(__props) {

const props = __props

const store = useStore()
const { path } = usePath()

const route = useRoute()
const router = useRouter()
const { authenticated, required2FA } = useAuthenticated()

const { logo, showUserAvatar } = useLogoImage()

const profile = computed<ComputedRef<Pick<CommunityStateTypes, 'me'>>>(() => store.getters[COMMUNITY_STORE.GETTERS.GET_ME]?.profile)
const userInfo = computed<ComputedRef<Pick<CommunityStateTypes, 'me'>>>(() => store.getters[COMMUNITY_STORE.GETTERS.GET_ME])
const profileCommunity = computed<any>(() => store.getters[COMMUNITY_STORE.GETTERS.COMMUNITY_INFO])
const isMobile = computed(() => store.getters[ROOT_STORE.GETTERS.CHECK_MOBILE_DEVICE])
const showUserList = computed(() => {
  return route?.params?.id && authenticated.value && profileCommunity.value?.member_display_setting
})

const imageUrl = ref('')
const dataImage = ref([])



watchEffect(() => {
  if (typeof profile.value?.image_url !== 'string' && profile.value?.image_url) {
    imageUrl.value = URL.createObjectURL(profile.value?.image_url)
    return
  } else {
    imageUrl.value = profile.value?.image_url
  }
  if (route?.params?.id) {
    dataImage.value = profileCommunity.value?.members_image_url
  }
})

onMounted(async () => {
  if (!route.path.match(`/${route.path?.split('/')[1]}/lobby`)) {
    if (route.params.id) {
      await communityServices.updateLoginCommunity(route.params?.id)
    }
  }
})

watch(
  () => route.path,
  async () => {
    if (!route.path.match(`/${route.path?.split('/')[1]}/lobby`) && !route.path.match(`/dashboard`)) {
      if (route.params.id) {
        await communityServices.updateLoginCommunity(route.params?.id)
      }
    }
  }
)

// 2022/10/12 VietNC Scenario test: no side menu UAT#4439(Ph2-R20221021)
const backToLobby = () => {
  if (route.path.match(`/${route.path.split('/')[1]}/lobby`)) {
    NProgress.start()
    NProgress.done()
  }
  router.push(`/${route.path.split('/')[1]}/lobby`)
}

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("header", {
      class: _normalizeClass(['d-flex bg-white pl-3 sticky-top shadow', _unref(profileCommunity)?.image_url ? '' : 'align-items-center'])
    }, [
      (_unref(route).params?.id)
        ? (_openBlock(), _createBlock(_component_router_link, {
            key: 0,
            to: `/${_unref(path)}/communities/${_unref(route).params?.id}`,
            class: _normalizeClass(['h-100 d-flex', _unref(profileCommunity)?.image_url ? 'background-image img-header' : 'align-items-center'])
          }, {
            default: _withCtx(() => [
              (_unref(profileCommunity)?.image_url)
                ? (_openBlock(), _createElementBlock("img", {
                    key: 0,
                    src: _unref(addCommunityHeaderParams)(_unref(logo)),
                    alt: "logo",
                    id: "logo"
                  }, null, 8, _hoisted_1))
                : (_openBlock(), _createElementBlock("img", {
                    key: 1,
                    src: require('@/assets/images/YELLoop_logo_slogan.svg'),
                    alt: "logo",
                    id: "logo2"
                  }, null, 8, _hoisted_2))
            ]),
            _: 1
          }, 8, ["to", "class"]))
        : (_openBlock(), _createElementBlock("div", {
            key: 1,
            class: "h-100 d-flex align-items-center cursor-pointer",
            onClick: backToLobby
          }, [
            _createElementVNode("img", {
              src: require('@/assets/images/YELLoop_logo_slogan.svg'),
              alt: "logo",
              id: "logo2"
            }, null, 8, _hoisted_3)
          ])),
      (_unref(showUserList))
        ? (_openBlock(), _createElementBlock("div", {
            key: 2,
            class: _normalizeClass([_unref(profileCommunity)?.image_url ? 'img ms-lg-4 ms-2' : 'img-defauld ms-2'])
          }, [
            (_unref(route)?.params?.id)
              ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                  _createElementVNode("h1", _hoisted_5, _toDisplayString(_unref(profileCommunity)?.name), 1)
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_6, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(dataImage.value, (item, index) => {
                return (_openBlock(), _createElementBlock("div", { key: item }, [
                  (!_unref(isMobile) ? index <= 8 : index <= 4)
                    ? (_openBlock(), _createBlock(_component_router_link, {
                        key: 0,
                        class: "image-user",
                        to: `/${_unref(path)}/communities/${_unref(route)?.params?.id}/users`
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_unref(Avatar), {
                            is_deleted_in_30_days: item.is_deleted_in_30_days,
                            user_image_url: item.image_url,
                            userType: item.user_type,
                            alt: "image_user",
                            class: "rounded-circle",
                            size: ""
                          }, null, 8, ["is_deleted_in_30_days", "user_image_url", "userType"])
                        ]),
                        _: 2
                      }, 1032, ["to"]))
                    : _createCommentVNode("", true)
                ]))
              }), 128)),
              (!_unref(isMobile) && _unref(profileCommunity)?.community_members_number > 9)
                ? (_openBlock(), _createElementBlock("span", _hoisted_7, "+" + _toDisplayString(_unref(numberWithCommas)(_unref(profileCommunity)?.community_members_number - 9)), 1))
                : _createCommentVNode("", true),
              (_unref(isMobile) && _unref(profileCommunity)?.community_members_number > 5)
                ? (_openBlock(), _createElementBlock("span", _hoisted_8, "+" + _toDisplayString(_unref(numberWithCommas)(_unref(profileCommunity)?.community_members_number - 5)), 1))
                : _createCommentVNode("", true)
            ])
          ], 2))
        : (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
            (_unref(route)?.params?.id)
              ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                  _createElementVNode("h1", _hoisted_10, _toDisplayString(_unref(profileCommunity)?.name), 1)
                ]))
              : _createCommentVNode("", true)
          ], 64)),
      (_unref(authenticated) && !_unref(required2FA))
        ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
            _hoisted_12,
            _createElementVNode("div", _hoisted_13, [
              (_unref(showUserAvatar))
                ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                    (_unref(profile))
                      ? (_openBlock(), _createElementBlock("div", _hoisted_15, _toDisplayString(_unref(userInfo)?.alumni_user_id ? _unref(profile)?.display_name : _unref(profile)?.family_name + ' ' + _unref(profile)?.given_name), 1))
                      : _createCommentVNode("", true),
                    _createElementVNode("img", {
                      class: "user__avatar rounded-circle d-none d-lg-flex",
                      src: imageUrl.value ? _unref(addUserIconParams)(imageUrl.value, _unref(userType)()) : require('@/assets/images/user-empty.svg')
                    }, null, 8, _hoisted_16)
                  ]))
                : _createCommentVNode("", true),
              _createVNode(Notification),
              _createVNode(UserMenu, {
                ShowMembership: __props.ShowMembership,
                ShowMembershipAlumni: __props.ShowMembershipAlumni
              }, null, 8, ["ShowMembership", "ShowMembershipAlumni"])
            ])
          ]))
        : _createCommentVNode("", true)
    ], 2),
    _createVNode(ButtonScrollTop),
    _createVNode(ModalLogout),
    _createVNode(ModalDetailNotification)
  ], 64))
}
}

})